import { type TPlayer, type TPlayerCreationResult } from '../../pages/PlayersPage/types'

export const checkingsCreateForm = (player: TPlayer) => {
    const {
        name = null,
        country = null,
        city = null,
        birthDate = null,
        height = null,
        weight = null,
        plays = null,
        avatar = null,
        initialRating = null,
        gender = null
    } = player

    if (!name) {
        return "Имя игрока не может быть пустым"
    }
    if (!country) {
        return "Страна не может быть пустым"
    }
    if (!city) {
        return "Город не может быть пустым"
    }
    if (!birthDate) {
        return "Дата рождения не может быть пустым"
    }
    if (!height) {
        return "Рост не может быть пустым"
    }
    if (!weight) {
        return "Вес не может быть пустым"
    }
    if (!plays) {
        return "Какой рукой играет не может быть пустым"
    }
    if (!avatar) {
        return "Фото игрока не может быть пустым"
    }
    if (!initialRating) {
        return "Начальный рейтинг не может быть пустым"
    }
    if (!gender) {
        return "Пол не может быть пустым"
    }

    return ""
}